export const SOUND_GAME_MUSIC        = 'gameMusic';
export const SOUND_INTERSECT_CUBE_1    = 'intersectCube1';
export const SOUND_INTERSECT_CUBE_2    = 'intersectCube2';
export const SOUND_INTERSECT_CUBE_3    = 'intersectCube3';
export const SOUND_INTERSECT_PADDLE  = 'intersectPaddle';
export const SOUND_BOOM  = 'boom';
export const SOUND_VICTORY_VOICE  = 'victory';
export const SOUND_LOSE_VOICE_1  = 'lose1';
export const SOUND_LOSE_VOICE_2  = 'lose2';
export const SOUND_START_VOICE  = 'start';

export const IMG_INTERACTOPUS_BG_BLACK = 'interactopusBgBlack';
export const IMG_INTERACTOPUS_BG_TRANS = 'interactopusBgTrans';

export const EVENT_FINAL_BLOCK_KILLED = 'finalBlockKilled';
export const EVENT_NO_LIVES = 'noLives';



/** WEBPACK FOOTER **
 ** ./src/names.js
 **/